"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceListYourProperty = void 0;
var React = require("react");
var PlaceListYourProperty = function (props) {
    return (React.createElement("div", { id: "list-your-property", className: "c-place__sell" },
        React.createElement("div", { className: "c-place__sell-box" },
            React.createElement("div", { style: { width: '100%' }, className: "l-container l-container--r48 l-container--stackable" },
                React.createElement("div", { className: "l-container__side" },
                    React.createElement("img", { loading: "lazy", className: "c-place__sell-img", src: "/res/img/key2.png", alt: "" })),
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: "c-place__sell-content" },
                        React.createElement("div", { className: "c-place__sell-title", dangerouslySetInnerHTML: { __html: props.t.listYourPropertyTitle } }),
                        React.createElement("div", { className: "c-place__sell-action" },
                            React.createElement("a", { target: "_blank", href: "/" + props.lang + "/list-property", className: "o-btn o-btn--primary", dangerouslySetInnerHTML: { __html: props.t.listYourPropertyCta } })),
                        React.createElement("div", { className: "c-place__sell-remark", dangerouslySetInnerHTML: { __html: props.t.listYourPropertyCaption } })))))));
};
exports.PlaceListYourProperty = PlaceListYourProperty;
